/* eslint-disable react/no-danger */
import { useEffect, useRef } from 'react';
import { transformToHtml } from '../../utils/CommonUtils';

export default function CityPWA(props) {
  useEffect(() => {
    document.body.classList.add('bodyClass');
    document.body.id = 'cmsintlflt';
    document.body.setAttribute('data-domain', 'www_intl_flight_makemytrip_com');
  });
  const { blocksData, pageData, isIntl, template_type: templateType, ccde, lang, appConfig, heading_and_searchbar: headingAndSearchBar = '', preLoadedState, jsSettingJson, tokenJson, intid, region } = props?.data || {};

  let cssPath;
  let jsPath;
  // let imagePath;
  // let minExt;
  let bankOfferPath;
  let intentOfferPath;
  let seoListingPath;
  let staticWidgetPath;
  let webVitalsPath;
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    intentOfferPath = `${jsPath}/intentOffer.min.js`;
    seoListingPath = `${cssPath}/seoListingMob.min.css`;
    bankOfferPath = `${cssPath}/bankOfferMob.min.css`;
    staticWidgetPath = lang === 'hin' ? `${jsPath}/hiStaticSeoWidgetMob.min.js` : `${jsPath}/staticSeoWidgetMob.min.js`;
    webVitalsPath = `${jsPath}/webVitalsScript.min.js`;
  } else {
    cssPath = 'http://localhost:3000/_next/static/css';
    jsPath = 'http://localhost:3000/_next/static/js';
    // imagePath = '/images';
    // minExt = '';
    intentOfferPath = `${jsPath}/intentOffer.min.js`;
    seoListingPath = `${cssPath}/seoListingMob.min.css`;
    bankOfferPath = `${cssPath}/bankOfferMob.min.css`;
    staticWidgetPath = lang === 'hin' ? `${jsPath}/hiStaticSeoWidgetMob.min.js` : `${jsPath}/staticSeoWidgetMob.min.js`;
    webVitalsPath = `${jsPath}/webVitalsScript.min.js`;
  }
  const tokenJsonString = tokenJson && tokenJson.length !== 0 ? `var tokenJson = ${JSON.stringify(tokenJson)}` : 'var tokenJson = {"prefilledDestCity":{"country":"India","iata":"BOM","city":"Mumbai, India","value":"Mumbai (BOM)"},"tokensList":{},"prefilledSrcCity":{"country":"India","iata":"DEL","city":"New Delhi, India","value":"New Delhi (DEL)"}};';
  const containerRef = useRef(null);
  const middleBlockHtml = `${blocksData?.contentTop ? blocksData.contentTop : ""}${blocksData?.contentMiddle ? blocksData.contentMiddle : ""}${pageData?.content ? pageData.content : ""}${blocksData?.contentBottom ? blocksData.contentBottom : ""}${blocksData?.bottomBlock ? blocksData.bottomBlock : ""}`;

  useEffect(() => {
    const buttons = containerRef.current?.querySelectorAll('.listing-card-wrpr');
    if (buttons) {
      buttons?.forEach(button => {
        const url = button.getAttribute('data-url');
        if (url) {
          button.onclick = () => window.location.replace(url);
        }
      });
    }
  }, [middleBlockHtml]);

  // Before passing, make sure the string has data-url instead of onclick
  const sanitizedHtml = middleBlockHtml.replace(
    /onclick="[^"]*"/,
    ''
  );
  return (
    <>
      <script dangerouslySetInnerHTML={{ __html: `
      window.__PRELOADED_STATE__ = '${preLoadedState}';
      window.showLeaveIntent = true;
      var mbox_id = 'New_homepage_Hero', top_mbox_id = 'HPLP_Topbar_New', dealsPerLoad = '12', dealMaxLoad = '48', voyagerURL = '//voyager.goibibo.com/api/v1/flights_search/find_node_by_name_v2/?limit=15&amp;country_filter_id=5597365951189135149', voyagerTimeout = '3000';
      var jsSettingJson = ${JSON.stringify(jsSettingJson)};
      ${appConfig?.settings ? `var flightsettings = ${JSON.stringify(appConfig.settings)};` : ''};
      ${tokenJsonString}
      var intid = "${intid || ''}";
      var mmt = {};
      mmt.hlp = {};
      var device = 'desktop';
      window.isIntl = ${isIntl || false};
      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = tokenJson?.noOfDaysToAddInDept, noOfDaysToAddInReturn = tokenJson?.noOfDaysToAddInReturn;
      var template = '${templateType}';
      window.template = '${templateType}';
      let ccdeVal = '${region ? `&ccde=${region}` : '&ccde=IN'}';
      ` }}
      />
      <script defer type="text/javascript" src={`${staticWidgetPath}`} />
      <script defer type="module" src={`${webVitalsPath}`} />
      <script type="text/javascript">
        {`window.FLTS = {};
        window.FLTS.listingStartTime = Date.now();`}
      </script>
      <style>{'.modify-search-header {position: relative;}'}</style>
      {/* <header className="modify-search-header" id="orderHeader">
        { transformToHtml(headingAndSearchBar) }
      </header> */}
      <header dangerouslySetInnerHTML={{ __html: `${headingAndSearchBar}` }} class="modify-search-header" id="orderHeader" />
      <script defer type="text/javascript" src={`${intentOfferPath}`} />
      <link href={`${seoListingPath}`} rel="stylesheet" />
      <link href={`${bankOfferPath}`} rel="stylesheet" />
      <div className="fli-intl-container prepend_top20 clearfix listingContainer">
        <div className="makeCenterCol clearfix noPadding">
          <div id="seoContentMiddle" className="seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12 paddL0 airline-left-container nopadding-mob paddR0 ">
            <div ref={containerRef}>
              {transformToHtml(sanitizedHtml)}
            </div>
          </div>
          <div id="seoRightBlock" className="seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ">
            {transformToHtml(blocksData?.filterBlock)}
            {transformToHtml(blocksData?.rightBlock)}
            {transformToHtml(blocksData?.leftBlock)}
          </div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: blocksData?.top_overlay }} />
      <script dangerouslySetInnerHTML={{ __html: '$(document).ready(function(){$(".viewFareBtn").click(function(e){e.preventDefault();$(this);let t=document.getElementsByClassName("hideCheapCards"),n=document.getElementById("viewFareBtn");if(n.parentNode.removeChild(n),t.length>0)for(var a=0;a<=t.length;a++)t[a]&&t[a].classList.remove("hideCheapCards")})});' }} />
    </>
  );
}
